import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailing-list',
  templateUrl: './mailing-list.component.html',
  styleUrls: ['./mailing-list.component.css']
})
export class MailingListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
